'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Panel = require('react-bootstrap/lib/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Panel3 = require('./Panel.scss');

var _Panel4 = _interopRequireDefault(_Panel3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownArrow = (0, _jsx3.default)(_reactFontawesome2.default, {
    className: _Panel4.default.arrow,
    icon: ['fas', 'caret-down']
});
var UpArrow = (0, _jsx3.default)(_reactFontawesome2.default, {
    className: _Panel4.default.arrow,
    icon: ['fas', 'caret-up']
});

var Panel = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Panel, _Component);

    function Panel() {
        (0, _classCallCheck3.default)(this, Panel);
        return (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).apply(this, arguments));
    }

    (0, _createClass3.default)(Panel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'eventKey', 'expanded', 'headerRole', 'headerTitle', 'panelRole']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                eventKey = _props.eventKey,
                expanded = _props.expanded,
                headerRole = _props.headerRole,
                headerTitle = _props.headerTitle,
                onSelect = _props.onSelect,
                panelRole = _props.panelRole;


            var header = (0, _jsx3.default)('h2', {
                className: _Panel4.default.header + ' ' + _Panel4.default['print-header']
            }, void 0, ' ', headerTitle, ' ', expanded ? UpArrow : DownArrow, ' ');

            var panelProps = {
                className: _Panel4.default.panel,
                collapsible: true,
                eventKey: eventKey,
                expanded: expanded,
                header: header,
                headerRole: headerRole,
                onSelect: onSelect,
                panelRole: panelRole
            };

            return _react2.default.createElement(
                _Panel2.default,
                panelProps,
                children
            );
        }
    }]);
    return Panel;
}(_react.Component), _class.defaultProps = {
    headerTitle: ''
}, _temp);
exports.default = Panel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Panels/Panel.js
// module id = oQLi
// module chunks = 57